<script lang="ts">
  import { icons } from "../utilities/icons";
  import YesNoModal from "../modals/YesNoModal.svelte";

  let { yes, no } = $props();
</script>

<!-- HTML ===================================================== -->

<YesNoModal {yes} {no}>
  {#snippet message()}
    <svg class="svg" viewBox={icons.trafficLightRed.viewBox}>
      {@html icons.trafficLightRed.path}
    </svg>
    {@html "&nbsp;Vil du afbryde træningen?"}
  {/snippet}
</YesNoModal>

<!-- CSS ===================================================== -->
<style>
  .svg {
    height: 1.2em;
    width: 1.2em;
    align-self: center;
    fill: currentColor;
  }
</style>
